import classNames from 'classnames';
import { Link, LinkProps } from 'react-router-dom';
import { Button } from 'yoso';
import { Translation } from '~/components/I18n';
import { useMember } from '~/components/Member/Member.hooks';
import { useMissionGroup, useMissionPageParams } from '~/components/Mission/Mission.hooks';
import { TabNav } from '~/components/Nav/Tab';
import styles from './MissionTabNav.module.scss';

export type MissionTabNavProps = {
  className?: string;
};

export const MissionTabNav = ({ className }: MissionTabNavProps) => {
  const { status } = useMissionPageParams();
  const { data } = useMissionGroup();
  const { all = [], partial = [], complete = [], end = [] } = data || {};

  const {
    data: { isLoggedIn },
  } = useMember();

  return (
    <TabNav className={classNames(styles.root, className)}>
      <li>
        <Button<LinkProps>
          className={classNames(styles.button, {
            [styles.active]: status === 'all',
          })}
          color="gray"
          as={Link}
          to={{ search: 'status=all' }}
          replace
          data-event="click"
          data-event-target="status_total_in_mission">
          <Translation name="citizen_mission_list_total" /> {isLoggedIn ? all.length : 0}
        </Button>
      </li>
      <li>
        <Button<LinkProps>
          className={classNames(styles.button, {
            [styles.active]: status === 'partial',
          })}
          color="gray"
          as={Link}
          to={{ search: 'status=partial' }}
          replace
          data-event="click"
          data-event-target="status_collecting_in_mission">
          <Translation name="citizen_mission_list_ing" /> {isLoggedIn ? partial.length : 0}
        </Button>
      </li>
      <li>
        <Button<LinkProps>
          className={classNames(styles.button, {
            [styles.active]: status === 'complete',
          })}
          color="gray"
          as={Link}
          to={{ search: 'status=complete' }}
          replace
          data-event="click"
          data-event-target="status_complete_in_mission">
          <Translation name="citizen_mission_list_complete" /> {isLoggedIn ? complete.length : 0}
        </Button>
      </li>
      <li>
        <Button<LinkProps>
          className={classNames(styles.button, {
            [styles.active]: status === 'end',
          })}
          color="gray"
          as={Link}
          to={{ search: 'status=end' }}
          replace
          data-event="click"
          data-event-target="status_expired_in_mission">
          <Translation name="citizen_mission_list_closed" /> {isLoggedIn ? end.length : 0}
        </Button>
      </li>
    </TabNav>
  );
};
